import { render, staticRenderFns } from "./WorkDetailFile.vue?vue&type=template&id=60b304da&scoped=true"
import script from "./WorkDetailFile.vue?vue&type=script&lang=js"
export * from "./WorkDetailFile.vue?vue&type=script&lang=js"
import style0 from "./WorkDetailFile.vue?vue&type=style&index=0&id=60b304da&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "60b304da",
  null
  
)

export default component.exports